const HOST_URL = (typeof window !== "undefined" && window.__IS_WHITELABEL__) ? window.location.origin : process.env.HOST_URL;
const baseURL = `${HOST_URL}/`;

/**
 *
 * Newsletter Service
 * @constructor
 *
 */

function ContactService() {}
ContactService.prototype.send = function (data) {
  return $.ajax({
    type: "POST",
    url: baseURL + "api/v1/utility/email",
    data: data,
  });
};

/**
 *
 * Newsletter Service
 * @constructor
 *
 */
function NewletterService() {}
NewletterService.prototype.send = function (data) {
  return $.ajax({
    type: "POST",
    url: baseURL + "api/v1/utility/subscribe",
    data: data,
  });
};

/**
 *
 * Login Service
 * @constructor
 *
 */

function LoginService() {}
LoginService.prototype.send = function (data) {
  return $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: baseURL + "auth/login",
    data: JSON.stringify(data),
  });
};

export { NewletterService, ContactService, LoginService };
